<template>
  <div class="main container-fluid profile-sub-page">
    <header class="page-hero">
      <div>
        <h4 class="page-hero__title mb-1">Интеграционные пароли</h4>
        <p class="page-hero__subtitle mb-0">Управление credential для WordPress, Telegram и других интеграций</p>
      </div>
      <router-link :to="{ name: 'Profile' }" class="btn btn-light btn-sm page-hero__back">
        <i class="bi bi-arrow-left me-1"></i>
        В профиль
      </router-link>
    </header>

    <section class="px-3 pb-3">
      <div class="panel-card">
        <div class="panel-card__header d-flex align-items-center justify-content-between gap-2">
          <span class="cloud-title mb-0">Список credential</span>
          <div class="profile-credentials__actions">
            <button class="btn btn-outline-secondary btn-sm" :disabled="credentialsLoading" @click="loadCredentials">Обновить</button>
            <button class="btn btn-primary btn-sm" @click="openCreate">Добавить</button>
            <button class="btn btn-outline-primary btn-sm" :disabled="!selectedCredentialId" @click="openEdit">Редактировать</button>
            <button class="btn btn-outline-danger btn-sm" :disabled="!selectedCredentialId || credentialDeleting" @click="deleteCredential">
              Удалить
            </button>
          </div>
        </div>

        <div class="panel-card__table p-0">
          <div v-if="credentialSaveSuccess" class="alert alert-success mx-3 mt-3 py-2 mb-2">{{ credentialSaveSuccess }}</div>
          <div v-if="credentialSaveError && !editorOpen" class="alert alert-danger mx-3 mt-3 py-2 mb-2">{{ credentialSaveError }}</div>
          <div v-if="credentialsError" class="alert alert-danger mx-3 mt-3 py-2 mb-2">{{ credentialsError }}</div>
          <div v-if="credentialsLoading" class="px-3 py-2 text-muted small">Загрузка списка...</div>

          <div class="table-responsive">
            <table class="table table-sm align-middle mb-0 credentials-table">
              <thead>
                <tr>
                  <th>Метка</th>
                  <th>Тип</th>
                </tr>
              </thead>
              <tbody v-if="credentials.length">
                <tr
                  v-for="item in credentials"
                  :key="item.id"
                  :class="{ 'table-active': Number(item.id) === selectedCredentialId }"
                  @click="selectCredential(item.id)"
                >
                  <td>{{ item.label || '—' }}</td>
                  <td><span class="badge-type">{{ item.type || '—' }}</span></td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="2" class="text-center text-muted py-3">Нет сохраненных записей</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>

    <div v-if="editorOpen" class="modal-backdrop credentials-modal-backdrop" @click.self="cancelEdit">
      <div class="modal-container credentials-modal-container">
        <div class="modal-header credentials-modal-header">
          <div class="credentials-cloud-title">
            {{ editorMode === 'edit' ? 'Редактирование credentials' : 'Новый credential' }}
          </div>
          <button type="button" class="modal-close modal-close--panel" @click="cancelEdit" aria-label="Close">&times;</button>
        </div>

        <div class="credentials-modal-body">
          <div v-if="credentialSaveError" class="alert alert-danger py-2 mb-2">{{ credentialSaveError }}</div>

          <form @submit.prevent="saveCredential" class="credentials-editor">
            <div class="credentials-editor__content">
              <aside class="credentials-editor__aside">
                <div class="credentials-panel__title">Параметры</div>

                <div class="credentials-aside__list">
                  <div class="credentials-aside__row">
                    <span class="credentials-aside__label">Режим</span>
                    <span class="credentials-aside__value">{{ editorMode === 'edit' ? 'Редактирование' : 'Создание' }}</span>
                  </div>
                  <div class="credentials-aside__row">
                    <span class="credentials-aside__label">Тип</span>
                    <span class="badge-type">{{ credentialForm.type || '—' }}</span>
                  </div>
                </div>

                <div class="credentials-aside__hint">
                  <template v-if="isWordpressType">
                    Для WordPress укажите метку, логин и пароль приложения.
                  </template>
                  <template v-else>
                    Для интеграции укажите метку, token и имя бота.
                  </template>
                </div>
              </aside>

              <section class="credentials-editor__main">
                <div class="credentials-panel__title">Данные credential</div>

                <div class="credentials-field">
                  <label class="left-headers form-label mb-0">Метка</label>
                  <input v-model.trim="credentialForm.label" type="text" class="form-control form-control-sm" required />
                </div>

                <div class="credentials-field">
                  <label class="left-headers form-label mb-0">Тип</label>
                  <select v-model="credentialForm.type" class="form-select form-select-sm" required>
                    <option v-for="type in credentialTypeOptions" :key="type" :value="type">{{ type }}</option>
                  </select>
                </div>

                <template v-if="isWordpressType">
                  <div class="credentials-field">
                    <label class="left-headers form-label mb-0">Логин</label>
                    <input v-model.trim="credentialForm.login" type="text" class="form-control form-control-sm" required />
                  </div>

                  <div class="credentials-field mb-0">
                    <label class="left-headers form-label mb-0">Пароль</label>
                    <input v-model.trim="credentialForm.password" type="text" class="form-control form-control-sm" required />
                  </div>
                </template>

                <template v-else>
                  <div class="credentials-field">
                    <label class="left-headers form-label mb-0">Token</label>
                    <input v-model.trim="credentialForm.token" type="text" class="form-control form-control-sm" required />
                  </div>

                  <div class="credentials-field mb-0">
                    <label class="left-headers form-label mb-0">Имя бота</label>
                    <input v-model.trim="credentialForm.botName" type="text" class="form-control form-control-sm" required />
                  </div>
                </template>
              </section>
            </div>

            <div class="credentials-modal-footer d-flex gap-2 justify-content-end">
              <button class="btn btn-outline-secondary btn-sm" type="button" :disabled="credentialSaving" @click="cancelEdit">
                Отмена
              </button>
              <button class="btn btn-primary btn-sm" type="submit" :disabled="credentialSaving">
                <span v-if="credentialSaving" class="spinner-border spinner-border-sm me-1"></span>
                {{ editorMode === 'edit' ? 'Сохранить' : 'Создать' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import axios from 'axios'
import { computed, onBeforeUnmount, onMounted, reactive, ref, watch } from 'vue'

const baseCredentialTypes = ['WORDPRESS', 'TELEGRAM', 'YANDEX_DZEN', 'X']

const credentialsLoading = ref(false)
const credentialsError = ref('')
const credentials = ref([])
const selectedCredentialId = ref(null)
const credentialDeleting = ref(false)
const credentialSaving = ref(false)
const credentialSaveError = ref('')
const credentialSaveSuccess = ref('')
const credentialMessageTimer = ref(null)
const editorOpen = ref(false)
const editorMode = ref('create')
const credentialForm = reactive({
  id: null,
  label: '',
  login: '',
  password: '',
  token: '',
  botName: '',
  type: baseCredentialTypes[0],
})

const credentialTypeOptions = computed(() => {
  const seen = new Set(baseCredentialTypes)
  credentials.value.forEach(item => {
    if (item?.type) seen.add(String(item.type))
  })
  return Array.from(seen)
})

const isWordpressType = computed(() => String(credentialForm.type || '').toUpperCase() === 'WORDPRESS')
const isTokenBotType = computed(() => !isWordpressType.value)

watch(() => credentialForm.type, () => {
  if (isWordpressType.value) {
    credentialForm.token = ''
    credentialForm.botName = ''
    return
  }
  credentialForm.login = ''
  credentialForm.password = ''
})

function extractErrorMessage(error, fallback) {
  const message = error?.response?.data?.message || error?.response?.data?.error || error?.response?.data?.data
  return String(message || fallback)
}

async function loadCredentials() {
  credentialsLoading.value = true
  credentialsError.value = ''
  try {
    const { data } = await axios.get('/api/credentials')
    credentials.value = Array.isArray(data) ? data : []
    const hasSelected = credentials.value.some(x => Number(x.id) === Number(selectedCredentialId.value))
    if (!hasSelected) selectedCredentialId.value = null
  } catch (error) {
    credentialsError.value = extractErrorMessage(error, 'Не удалось загрузить список credentials.')
    credentials.value = []
    selectedCredentialId.value = null
  } finally {
    credentialsLoading.value = false
  }
}

function clearCredentialMessages() {
  if (credentialMessageTimer.value) {
    clearTimeout(credentialMessageTimer.value)
    credentialMessageTimer.value = null
  }
  credentialSaveError.value = ''
  credentialSaveSuccess.value = ''
}

function showCredentialSuccess(message) {
  clearCredentialMessages()
  credentialSaveSuccess.value = String(message || '')
  credentialMessageTimer.value = setTimeout(() => {
    credentialSaveSuccess.value = ''
    credentialMessageTimer.value = null
  }, 3500)
}

function showCredentialError(message) {
  clearCredentialMessages()
  credentialSaveError.value = String(message || '')
  credentialMessageTimer.value = setTimeout(() => {
    credentialSaveError.value = ''
    credentialMessageTimer.value = null
  }, 5000)
}

function selectCredential(id) {
  selectedCredentialId.value = Number(id)
}

function resetCredentialForm() {
  credentialForm.id = null
  credentialForm.label = ''
  credentialForm.login = ''
  credentialForm.password = ''
  credentialForm.token = ''
  credentialForm.botName = ''
  credentialForm.type = baseCredentialTypes[0]
}

function openCreate() {
  clearCredentialMessages()
  editorMode.value = 'create'
  editorOpen.value = true
  resetCredentialForm()
}

async function openEdit() {
  if (!selectedCredentialId.value) return
  clearCredentialMessages()
  editorMode.value = 'edit'
  editorOpen.value = true

  try {
    const { data } = await axios.get(`/api/credentials/by-id/${selectedCredentialId.value}`)
    const item = data || {}
    credentialForm.id = Number(item.id)
    credentialForm.label = String(item.label || '')
    credentialForm.type = String(item.type || baseCredentialTypes[0])
    credentialForm.login = String(item.login || '')
    credentialForm.password = String(item.password || '')
    credentialForm.token = String(item.token || '')
    credentialForm.botName = String(item.botName || '')
  } catch (error) {
    credentialSaveError.value = extractErrorMessage(error, 'Не удалось загрузить credential для редактирования.')
  }
}

function validateCredentialForm() {
  if (!credentialForm.label.trim()) return 'Заполните поле "Метка".'
  if (!credentialForm.type.trim()) return 'Выберите тип credential.'
  if (isWordpressType.value) {
    if (!credentialForm.login.trim() || !credentialForm.password.trim()) {
      return 'Для WORDPRESS обязательны логин и пароль.'
    }
  }
  if (isTokenBotType.value) {
    if (!credentialForm.token.trim() || !credentialForm.botName.trim()) {
      return 'Для выбранного типа обязательны token и botName.'
    }
  }
  return ''
}

async function saveCredential() {
  clearCredentialMessages()
  const validationError = validateCredentialForm()
  if (validationError) {
    credentialSaveError.value = validationError
    return
  }

  credentialSaving.value = true
  try {
    const payload = {
      label: credentialForm.label.trim(),
      type: credentialForm.type.trim(),
      login: isWordpressType.value ? (credentialForm.login.trim() || null) : null,
      password: isWordpressType.value ? (credentialForm.password.trim() || null) : null,
      token: isWordpressType.value ? null : (credentialForm.token.trim() || null),
      botName: isWordpressType.value ? null : (credentialForm.botName.trim() || null),
    }

    let savedId = null
    if (editorMode.value === 'edit' && credentialForm.id) {
      const { data } = await axios.put(`/api/credentials/${credentialForm.id}`, payload)
      savedId = Number(data?.id || credentialForm.id)
      showCredentialSuccess('Credential обновлен.')
    } else {
      const { data } = await axios.post('/api/credentials', payload)
      savedId = Number(data?.id || 0) || null
      showCredentialSuccess('Credential создан.')
    }

    await loadCredentials()
    if (savedId) selectedCredentialId.value = savedId
    editorOpen.value = false
  } catch (error) {
    showCredentialError(extractErrorMessage(error, 'Не удалось сохранить credential.'))
  } finally {
    credentialSaving.value = false
  }
}

function cancelEdit() {
  editorOpen.value = false
  clearCredentialMessages()
}

function onKeydown(event) {
  if (event.key === 'Escape' && editorOpen.value) {
    cancelEdit()
  }
}

async function deleteCredential() {
  if (!selectedCredentialId.value) return
  const ok = window.confirm('Удалить выбранный credential?')
  if (!ok) return

  credentialDeleting.value = true
  clearCredentialMessages()
  try {
    await axios.delete(`/api/credentials/${selectedCredentialId.value}`)
    selectedCredentialId.value = null
    editorOpen.value = false
    showCredentialSuccess('Credential удален.')
    await loadCredentials()
  } catch (error) {
    showCredentialError(extractErrorMessage(error, 'Не удалось удалить credential.'))
  } finally {
    credentialDeleting.value = false
  }
}

onMounted(async () => {
  window.addEventListener('keydown', onKeydown)
  await loadCredentials()
})

onBeforeUnmount(() => {
  window.removeEventListener('keydown', onKeydown)
  if (credentialMessageTimer.value) {
    clearTimeout(credentialMessageTimer.value)
    credentialMessageTimer.value = null
  }
})
</script>

<style scoped>
/* ── Shared profile sub-page shell (matches ProfilePage / streams pages) ──── */
.profile-sub-page {
  min-height: 100%;
  padding-top: 10px;
  background:
    radial-gradient(circle at 2% 3%, rgba(66, 153, 225, 0.2), transparent 36%),
    radial-gradient(circle at 98% 2%, rgba(56, 189, 248, 0.18), transparent 32%),
    #f3f7ff;
}

.page-hero {
  margin: 0 20px 12px;
  padding: 14px 16px;
  border-radius: 16px;
  background: linear-gradient(135deg, #10305f 0%, #1b4f93 60%, #1e67b7 100%);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 18px 40px rgba(16, 48, 95, 0.22);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.page-hero__title { font-weight: 800; letter-spacing: 0.01em; }
.page-hero__subtitle { color: rgba(232, 242, 255, 0.92); font-size: 13px; }
.page-hero__back { color: #103f77; border-color: #cfe2ff; font-weight: 700; white-space: nowrap; }

.panel-card {
  border-radius: 16px;
  border: 1px solid #dfe7f5;
  background: #fff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.panel-card__header {
  padding: 12px 14px;
  border-bottom: 1px solid #e8eef8;
  background: #f8fbff;
}

.cloud-title {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid #d8e5fb;
  background: linear-gradient(180deg, #f2f7ff 0%, #eaf2ff 100%);
  color: #2f4f88;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.01em;
  box-shadow: 0 4px 10px rgba(49, 94, 227, 0.08);
}

.profile-credentials__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow-x: auto;
  max-width: 100%;
  padding-bottom: 2px;
  scrollbar-width: thin;
}

.profile-credentials__actions > * {
  flex: 0 0 auto;
}

.credentials-table tbody tr {
  cursor: pointer;
}

.badge-type {
  display: inline-block;
  border-radius: 999px;
  border: 1px solid #d9e2f3;
  padding: 2px 8px;
  color: #324462;
  font-size: 11px;
  font-weight: 700;
  background: #f8fbff;
}

.table thead th {
  color: #607089;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: .04em;
  padding: 10px 16px;
  border-bottom-width: 1px;
  border-color: #e9edf6;
  background: #fbfcfe;
}

.table tbody td {
  padding: 10px 16px;
  border-color: #edf1f7;
  color: #2b3f61;
  font-size: 13px;
}

.credentials-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.48);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
  padding: 10px;
}

.credentials-modal-container {
  width: min(96vw, 860px);
  max-height: min(94vh, 860px);
  background: #fff;
  border: 1px solid #dfe7f5;
  border-radius: 16px;
  box-shadow: 0 24px 52px rgba(15, 23, 42, 0.24);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.credentials-modal-header {
  position: relative;
  display: flex;
  justify-content: flex-end;
  padding: 10px 12px 0;
  min-height: 44px;
}

.credentials-cloud-title {
  position: absolute;
  left: 14px;
  top: 10px;
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid #d8e5fb;
  background: linear-gradient(180deg, #f2f7ff 0%, #eaf2ff 100%);
  color: #2f4f88;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.01em;
  box-shadow: 0 4px 10px rgba(49, 94, 227, 0.08);
}

.credentials-modal-body {
  padding: 0 12px 12px;
  overflow-y: auto;
  min-height: 0;
}

.credentials-editor {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.credentials-editor__content {
  display: grid;
  grid-template-columns: minmax(220px, 0.9fr) minmax(0, 1.1fr);
  gap: 12px;
  min-height: 0;
}

.credentials-editor__aside,
.credentials-editor__main {
  border: 1px solid #e1eaf8;
  border-radius: 12px;
  padding: 12px;
  min-height: 0;
}

.credentials-editor__aside {
  background: #f8fbff;
}

.credentials-editor__main {
  background: #fbfdff;
}

.credentials-panel__title {
  display: inline-flex;
  align-items: center;
  margin-bottom: 8px;
  padding: 5px 9px;
  border-radius: 999px;
  border: 1px solid #d8e5fb;
  background: #eff5ff;
  color: #3b5690;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.credentials-aside__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.credentials-aside__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.credentials-aside__label {
  color: #677995;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.credentials-aside__value {
  color: #283a58;
  font-size: 12px;
  font-weight: 700;
}

.credentials-aside__hint {
  margin-top: 10px;
  border: 1px solid #d9e6fb;
  border-radius: 10px;
  background: #f3f7ff;
  padding: 8px 10px;
  color: #4a5f86;
  font-size: 12px;
  line-height: 1.35;
}

.credentials-field {
  margin-bottom: 8px;
}

.left-headers {
  padding-left: 1px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: #4d5f82;
  text-transform: uppercase;
}

.credentials-editor__main .form-control,
.credentials-editor__main .form-select {
  border-radius: 10px;
}

.credentials-editor__main .form-control:focus,
.credentials-editor__main .form-select:focus {
  border-color: #95b8ff;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.14);
}

.credentials-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 0 0;
  margin-top: 10px;
  border-top: 1px solid #e7edf8;
}

.credentials-modal-footer .btn {
  min-width: 90px;
  padding: 0.3rem 0.65rem;
  font-size: 0.84rem;
}

.modal-close--panel {
  width: 34px;
  height: 34px;
  border: 1px solid #dce6f6;
  border-radius: 10px;
  background: #fff;
  color: #6c7a95;
  font-size: 24px;
  line-height: 1;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s ease, color 0.15s ease, transform 0.15s ease;
}

.modal-close--panel:hover {
  background: #f3f6fd;
  color: #2e3d59;
  transform: scale(1.02);
}

.modal-close--panel:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.2);
}

@media (max-width: 920px) {
  .credentials-editor__content {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .credentials-modal-backdrop {
    padding: 8px;
  }

  .credentials-modal-container {
    width: 100%;
    max-height: 96vh;
    border-radius: 12px;
  }

  .credentials-modal-body {
    padding: 0 10px 10px;
  }

  .credentials-editor__content {
    gap: 10px;
  }

  .credentials-editor__aside,
  .credentials-editor__main {
    padding: 10px;
  }
}

@media (max-width: 992px) {
  .page-hero {
    margin: 0 12px 12px;
    flex-direction: column;
    align-items: flex-start;
  }

  .profile-credentials__actions {
    width: 100%;
    justify-content: flex-start;
  }
}
</style>
